import { action } from 'typesafe-actions';
import { FinanceActionTypes } from './types';

export const createUpdateFinanceFieldAction = (fieldName: string, value: any, refValue?: any) =>
  action(FinanceActionTypes.UPDATE_FINANCE_FIELD, {
    fieldName,
    value,
    refValue,
  });
